import { vaultFetch } from './vault-api-core.ts'
import type { VaultDaemonStatus } from './vault-api-daemons.ts'

export interface VaultTenantKeyDaemon {
  id: string
  status: VaultDaemonStatus
  kekVersionHeld: number | null
}

export interface VaultTenantKeyOut {
  initialised: boolean
  tenantPubkey: string | null
  currentKekVersion: number | null
  daemons: VaultTenantKeyDaemon[]
  [key: string]: unknown
}

export interface VaultWrappedDek {
  valueId: string
  wrappedDek: string
  kekVersion: number
}

// ── tenant key ──────────────────────────────────────────────────────────
export function getTenantKey(rootId: string): Promise<VaultTenantKeyOut> {
  return vaultFetch<VaultTenantKeyOut>(`/vault/admin/${rootId}/tenant-key`)
}

export function initTenantKey(
  rootId: string,
  tenantPubkey: string,
): Promise<{ tenantPubkey: string; currentKekVersion: number }> {
  return vaultFetch(`/vault/admin/${rootId}/tenant-key/init`, {
    method: 'POST',
    body: JSON.stringify({ tenantPubkey }),
  })
}

export async function listWrappedDeks(
  rootId: string,
): Promise<VaultWrappedDek[]> {
  const { values } = await vaultFetch<{ values: VaultWrappedDek[] }>(
    `/vault/admin/${rootId}/tenant-key/wrapped-deks`,
  )
  return values
}

export function rotateTenantKey(
  rootId: string,
  body: {
    tenantPubkey: string
    rewrapped: { valueId: string; wrappedDek: string }[]
    deliveries: { daemonId: string; wrappedKek: string }[]
  },
): Promise<{ version: number }> {
  return vaultFetch(`/vault/admin/${rootId}/tenant-key/rotate`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
